module.exports = __webpack_public_path__ + "img/zi_4.2157bb3c.png";